import React, {useState} from 'react';
import TenantDetails from './TenantDetails';

import { ZERO_VALUE, ONE_VALUE } from "@utils/constants";

function NewMatching() {
  const [key, setKey] = useState(ZERO_VALUE);

  const resetComponent = () => {
    setKey(prevKey => prevKey + ONE_VALUE);
  };

  return (
    <div className='w-full flex flex-col items-center'>
      <TenantDetails key={key} resetComponent={resetComponent} />
    </div>
  );
}

export default NewMatching